import * as React from "react";
import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {
  Button,
  Typography,
  Checkbox,
  FormGroup,
  TextField,
  Divider,
  Box,
  FormHelperText,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import { myWordsQuery } from "../../../../../validations/myWordsValidation";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function ReferralCodeQuery(props) {
  const { setQueryMyReferralCodesData, getMyReferralCodesFromBack } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const initialValues = {
    marketingCode: "",
    createdAt_start: "",
    createdAt_end: "",
    status: "",
  };

  const onSubmit = (values, props) => {
    let newValues = {
      marketingCode: values.marketingCode,
      createdAt_start: values.createdAt_start,
      createdAt_end: values.createdAt_end,
      status: values.status,
    };
    for (const property in newValues) {
      if (typeof newValues[property] == "boolean") continue;
      if (!newValues[property]) delete newValues[property];
    }

    setQueryMyReferralCodesData(newValues);
    getMyReferralCodesFromBack("getUserCodesApi", newValues);
  };

  const handleDateTime = (date, props, Field) => {
    date.convert(gregorian);
    let DateForSend = new DateObject({ date, calender: gregorian }).format(
      "YYYY-MM-DD"
    );
    // console.log("DateForSend", DateForSend);
    props.setFieldValue(Field, DateForSend);
    date.convert(persian);
  };
  const calenderDigits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={myWordsQuery}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    ></StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"کد"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="marketingCode"
                        label="کد"
                        placeholder="کد"
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="marketingCode" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ ساخت) از تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                        onChange={(event) => {
                          handleDateTime(event, props, "createdAt_start");
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="createdAt_start" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"(تاریخ ساخت) تا تاریخ"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <DatePicker
                        digits={calenderDigits}
                        dateFormat="yyyy-MM-dd"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        // onChange={(event)=>{console.log(event,props);console.log(new DateObject({date:event,calender:gregorian}).format("YYYY-MM-DD"))}}
                        onChange={(event) => {
                          handleDateTime(event, props, "createdAt_end");
                        }}
                      />
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="createdAt_start" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"وضعیت"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl
                        component="fieldset"
                        sx={{
                          mx: 1,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Field
                          as={RadioGroup}
                          onClick={(e) => {
                            // console.log(e.target.value);
                          }}
                          aria-label="status"
                          name="status"
                          sx={{ display: "flex", flexDirection: "row" }}
                        >
                          <FormControlLabel
                            value={true}
                            control={<Radio />}
                            label="فعال"
                          />
                          <FormControlLabel
                            value={false}
                            control={<Radio />}
                            label="غیرفعال"
                          />
                          <FormControlLabel
                            value=""
                            control={<Radio />}
                            label="همه"
                          />
                        </Field>
                        <FormHelperText
                          sx={{ color: "#f96767", textAlign: "center" }}
                        >
                          <ErrorMessage name="status" />
                        </FormHelperText>
                      </FormControl>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              جستجو
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
  // <Box
  //   sx={{
  //     textAlign: "center",
  //     my: 1,
  //   }}
  // >
  //   <FormControl>
  //     {/* <FormLabel id="selectedPackages">پکیج های من</FormLabel> */}
  //     <Typography variant="h6" gutterBottom>
  //       پکیج های من
  //     </Typography>
  //     <RadioGroup
  //       row
  //       aria-labelledby="selectedPackages"
  //       name="selectedPackages"
  //       onChange={handleSelectedPackage}
  //       // value={selectedPackage}
  //     >
  //       <FormControlLabel value="true" control={<Radio />} label="معتبر" />
  //       <FormControlLabel
  //         value="false"
  //         control={<Radio />}
  //         label="غبر معتبر"
  //       />
  //       <FormControlLabel value="all" control={<Radio />} label="همه" />
  //     </RadioGroup>
  //     <Button onClick={clicktoback} variant="contained">مشاهده</Button>
  //   </FormControl>
  // </Box>
  // );
}
